import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import { useDispatch, useSelector } from 'react-redux';
import { setStageTab } from '../../../store/user/userSlice';
import { useNavigate } from 'react-router-dom';
import { get_sidebar_menu, clearSearchFilters } from '../../../store/job/jobSlice';
import { SvgIcon } from '@mui/material';
import * as MuiIcons from '@mui/icons-material';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';


const JobsSvgIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <g>
            <path d="M8 9C8 9.55228 7.55228 10 7 10C7 10 1 10 1 10C0.447715 10 0 9.55228 0 9C0 9 0 1 0 1C0 0.447715 0.447715 0 1 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(3 12)" />
            <path d="M8 9C8 9.55228 7.55228 10 7 10C7 10 1 10 1 10C0.447715 10 0 9.55228 0 9C0 9 0 1 0 1C0 0.447715 0.447715 0 1 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(8 7)" />
            <path d="M8 4C8 3.47004 7.78932 2.96137 7.4143 2.5863C7.4143 2.5863 5.4143 0.586303 5.4143 0.586303C5.03929 0.211019 4.53054 0.000113249 4 0C4 0 1 0 1 0C0.447715 0 0 0.447715 0 1C0 1 0 9 0 9C0 9.55228 0.447715 10 1 10C1 10 7 10 7 10C7.55228 10 8 9.55229 8 9C8 9 8 4 8 4Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(13 2)" />
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);


const ApprovalSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <g>
        <g>
          <path d="M16 11.0005C16 16.0005 12.5 18.5004 8.34 19.9504C8.12216 20.0243 7.88554 20.0207 7.67 19.9404C3.5 18.5004 0 16.0005 0 11.0005C0 11.0005 0 4.00045 0 4.00045C0 3.44816 0.447715 3.00045 1 3.00045C3 3.00045 5.5 1.80045 7.24 0.28045C7.67767 -0.0934832 8.32233 -0.0934833 8.76 0.28045C10.51 1.81045 13 3.00045 15 3.00045C15.5523 3.00045 16 3.44816 16 4.00045C16 4.00045 16 11.0005 16 11.0005Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(4 2)" />
          <path d="M0 2L2 4L6 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(9 10)" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

const SettingsSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <path d="M6.62757 2.11858C6.74174 0.917419 7.7505 0 8.95707 0C10.1636 2.38419e-07 11.1724 0.91742 11.2866 2.11858C11.3538 2.87852 11.7872 3.55798 12.448 3.93925C13.1088 4.32053 13.914 4.35573 14.6056 4.03358C15.7018 3.53587 16.9968 3.95121 17.5991 4.99368C18.2014 6.03615 17.9143 7.36549 16.9356 8.06658C16.3113 8.50463 15.9396 9.21943 15.9396 9.98208C15.9396 10.7447 16.3113 11.4595 16.9356 11.8976C17.9143 12.5987 18.2013 13.928 17.5991 14.9705C16.9968 16.0129 15.7018 16.4283 14.6056 15.9306C13.914 15.6084 13.1088 15.6436 12.448 16.0249C11.7872 16.4062 11.3538 17.0856 11.2866 17.8456C11.1724 19.0467 10.1636 19.9642 8.95707 19.9642C7.75049 19.9642 6.74174 19.0467 6.62757 17.8456C6.56048 17.0854 6.12688 16.4056 5.4658 16.0243C4.80471 15.643 3.99922 15.608 3.30757 15.9306C2.21132 16.4283 0.916318 16.0129 0.314049 14.9705C-0.288221 13.928 -0.00118232 12.5987 0.977567 11.8976C1.60186 11.4595 1.97352 10.7447 1.97352 9.98208C1.97352 9.21943 1.60186 8.50463 0.977567 8.06658C0.00024128 7.36518 -0.286043 6.03702 0.315546 4.99529C0.917135 3.95355 2.21058 3.53767 3.30657 4.03358C3.99812 4.35572 4.8033 4.32052 5.46411 3.93925C6.12491 3.55798 6.55836 2.87852 6.62557 2.11858" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(3.043 2.017)" />
      <path d="M0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(9 9)" />
    </g>
  </SvgIcon>
);

const QuotesSvgIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <g>
            <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(2 2)" />
            <path d="M8 0C8 0 2 0 2 0C0.895431 0 0 0.895431 0 2C0 3.10457 0.895431 4 2 4C2 4 6 4 6 4C7.10457 4 8 4.89543 8 6C8 7.10457 7.10457 8 6 8C6 8 0 8 0 8" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(8 8)" />
            <path d="M0 12L0 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(12 6)" />
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);


const StageList = ({ company_process_stage = [], selected_stage_tab, selected_process_tab, ChildComponent }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sidebar_menus, search_query, searchFilters } = useSelector((state) => state.job);
  const { company_process } = useSelector((state) => state.user);

  useEffect(() => {
    const qn = searchFilters.map(f => f.value.trim());
    if (search_query && !qn.includes(search_query)) {
      qn.push(search_query);
    }
    const column = searchFilters.map(f => f.key).filter(Boolean);

    dispatch(get_sidebar_menu({
      process_id: selected_process_tab,
      qn,
      column
    }));
  }, [dispatch, selected_process_tab, search_query, searchFilters]);
  const [openSections, setOpenSections] = useState({});

  useEffect(() => {
    if (sidebar_menus.length > 0) {
      const initialOpen = { library: true, settings: true };
      sidebar_menus.forEach(menu => {
        initialOpen[menu.id] = true;
      });
      setOpenSections(initialOpen);
    }
  }, [sidebar_menus]);

  const toggleSection = (key) => {
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleStageChange = (stage) => {
    const { id, name } = stage;
    dispatch(clearSearchFilters());
    dispatch(setStageTab(id));
    navigate('/');
  };

  const getHeadingIcon = (iconName, label = "") => {
    const iconStr = String(iconName || "").toLowerCase();
    const labelStr = String(label || "").toLowerCase();

    if (labelStr.includes('job') || iconStr.includes('job')) return <JobsSvgIcon />;

    if (labelStr.includes('approval') || iconStr.includes('approval') || iconStr.includes('check')) return <ApprovalSvgIcon />;
    if (labelStr.includes('settings') || iconStr.includes('settings')) return <SettingsSvgIcon />;
    if (labelStr.includes('quote') || iconStr.includes('quote')) return <QuotesSvgIcon />;

    if (iconName && MuiIcons[iconName]) {
      const Icon = MuiIcons[iconName];
      return <Icon />;
    }

    return <MuiIcons.CheckCircleOutlineOutlined />;
  };

  const getDynamicHeadings = () => {
    // Find current process
    const currentProcess = company_process.find(p => p.id === selected_process_tab);

    // Check if proof feature is active
    const isProofActive = currentProcess && (currentProcess.standard_proof || currentProcess.annotated_proof);

    const dynamic = sidebar_menus
      .filter(menu => {
        if (menu.side_name.includes('Artwork Approval')) {
          return isProofActive;
        }
        return true;
      })
      .map(menu => ({
        key: menu.id,
        label: menu.side_name,
        icon: getHeadingIcon(menu.side_icon, menu.side_name),
        stages: menu.stages
      }));



    return dynamic;
  };
  const getItemIcon = (stage) => {
    const { name, id, stage_logo } = stage;
    const sx = { fontSize: 18, color: '#c0c0c0', mr: 1.25 };

    if (stage_logo) {
      return (
        <Box
          component="img"
          src={stage_logo}
          alt={name}
          sx={{
            width: 18,
            height: 18,
            mr: 1.25,
            objectFit: 'contain',
            // enhance visibility if the logo is dark on dark or light on light, 
            // but usually icons are prepared well. 
            // We can add specific styles if needed.
          }}
        />
      );
    }

    const n = String(name || "").toLowerCase();

    if (n.includes('requested')) return <VerticalAlignTopIcon sx={sx} />;
    if (n.includes('progress')) return <AutorenewOutlinedIcon sx={sx} />;
    if (n.includes('complete')) return <CheckCircleOutlineIcon sx={sx} />;
    if (n.includes('hold')) return <PauseCircleOutlineOutlinedIcon sx={sx} />;
    if (n.includes('archive')) return <Inventory2OutlinedIcon sx={sx} />;
    if (n.includes('reject')) return <CancelOutlinedIcon sx={sx} />;

    return <RadioButtonUncheckedOutlinedIcon sx={sx} />;
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#FFF5F2' }}>
      {/* ===== SIDEBAR ===== */}
      <Box
        sx={{
          width: 240,
          bgcolor: '#fff',
          borderRight: '1px solid #e8e8e8',
          py: 3
        }}
      >
        <List sx={{ px: 2.5, pl: 3 }}>
          {getDynamicHeadings().map(({ key, label, icon, stages }) => (
            <Box key={key}>
              {/* ===== HEADING ===== */}
              <ListItem disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                  onClick={() => toggleSection(key)}
                  sx={{
                    px: 0,
                    py: 0.2,
                    gap: 0.75,
                    '&:hover': { bgcolor: 'transparent' }
                  }}
                >
                  <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: '#313131ff',
                      fontFamily: "'Inter Tight', sans-serif"
                    }}
                    sx={{ flex: 'none' }}
                  />
                  {React.cloneElement(icon, {
                    sx: { fontSize: 18, color: '#9e9e9e' }
                  })}
                </ListItemButton>
              </ListItem>

              {/* ===== ITEMS ===== */}
              <Collapse in={openSections[key]} timeout="auto" unmountOnExit>
                <List disablePadding sx={{ mb: 1 }}>
                  {stages.map((stage, index) => {
                    const isActive = selected_stage_tab === stage.id;
                    return (
                      <ListItem key={`${key}-${stage.id}-${index}`} disablePadding sx={{ mb: 0 }}>
                        <ListItemButton
                          onClick={() => handleStageChange(stage)}
                          sx={{
                            px: 0,
                            py: 0.15,
                            '&:hover': { bgcolor: 'transparent' }
                          }}
                        >
                          {getItemIcon(stage)}
                          <ListItemText
                            primary={`${stage.name} - ${stage.job_count || 0}`}
                            primaryTypographyProps={{
                              fontSize: 15,
                              color: isActive ? '#f4511e' : '#9e9e9e',
                              fontWeight: isActive ? 500 : 400,
                              fontFamily: "'Inter Tight', sans-serif"
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>

      {/* ===== CONTENT AREA ===== */}
      <Box sx={{ flex: 1, p: 3 }}>
        <ChildComponent />
      </Box>
    </Box>
  );
};

export default StageList;
